module.exports = __webpack_public_path__ + "es_ES-download-b9543f.webp";